import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDButton from "../../../../../components/MDButton";

import articleService from "../../../../../services/articleService";

function ActionCell({ id, action, icon, color, onDelete, setNotification }) {

  const handleDelete = async (id) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("¿Estás seguro de que quieres eliminar este artículo?")) {
      try {
        await articleService.delete(id);
        if (onDelete) onDelete();
        if (setNotification) setNotification({
          open: true,
          color: "success",
          title: "Artículo eliminado",
          content: "El artículo ha sido eliminado correctamente.",
        });
      } catch (error) {
        console.error(error.message);
        if (setNotification) setNotification({
          open: true,
          color: "error",
          title: "Error",
          content: error.message,
        });
      }
    }
  };
  return (
    <MDBox display="flex" alignItems="center">
      <MDBox mr={1}>
        {action === "details" ? (
          <MDButton
            component={Link}
            to={`/articles/details/${id}`}
            variant="outlined"
            color={color}
            size="small"
            iconOnly
          >
            <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
          </MDButton>
        ) : null}
        {action === "edit" ? (
          <MDButton
            component={Link}
            to={`/articles/edit/${id}`}
            variant="outlined"
            color={color}
            size="small"
            iconOnly
          >
            <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
          </MDButton>
        ) : null}
        {action === "delete" ? (
          <MDButton
            variant="outlined"
            color={color}
            size="small"
            iconOnly
            onClick={() => handleDelete(id)}
          >
            <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
          </MDButton>
        ) : null}
      </MDBox>
    </MDBox>
  );
}

// Typechecking props for the StatusCell
ActionCell.propTypes = {
  id: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  setNotification: PropTypes.func,
};

export default ActionCell;
